import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { ProfileApi, type postSecurityQuestionsRequest } from '@shared/api';

interface SecurityQuestionsType {
  loading: boolean;
  error: string | null;
  success: boolean;
  post: (request: postSecurityQuestionsRequest, signal?: AbortSignal) => Promise<void>;
  resetError: () => void;
  clear: () => void;
}

export const usePostSecurityQuestionsStore = create<SecurityQuestionsType>((set) => ({
  loading: false,
  error: null,
  success: false,

  post: async (request, signal) => {
    try {
      set({ loading: true, success: false });
      await ProfileApi.postSecurityQuestions(request, signal);
      set({ loading: false, success: true });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  resetError: () => set({ error: null }),

  clear: () => set({ loading: false, error: null, success: false }),
}));
